module.exports = __webpack_public_path__ + "static/media/huawei-p30_aurora--watch.cb464363.png";